import { useState, useEffect } from 'react'
import api from '../services/api'
import { useSlug } from '../hooks/useSlug'

function formatarCPF(v) { return v.replace(/\D/g,'').replace(/(\d{3})(\d)/,'$1.$2').replace(/(\d{3})(\d)/,'$1.$2').replace(/(\d{3})(\d{1,2})$/,'$1-$2').slice(0,14) }
function formatarCNPJ(v) { return v.replace(/\D/g,'').replace(/(\d{2})(\d)/,'$1.$2').replace(/(\d{3})(\d)/,'$1.$2').replace(/(\d{3})(\d)/,'$1/$2').replace(/(\d{4})(\d{1,2})$/,'$1-$2').slice(0,18) }

export default function ProtocoloPublico() {
  const SLUG = useSlug() || 'santarosa'
  const [orgao, setOrgao] = useState(null)
  const [form, setForm] = useState({ nome:'', cpf_cnpj:'', email:'', telefone:'', assunto:'', tipoPessoa:'PF' })
  const [arquivo, setArquivo] = useState(null)
  const [erro, setErro] = useState('')
  const [load, setLoad] = useState(false)
  const [protocolo, setProtocolo] = useState(null)

  useEffect(() => {
    api.get(`/configuracoes/publico/${SLUG}`).then(r => setOrgao(r.data)).catch(() => {})
  }, [])

  const set = (k,v) => setForm(f => ({...f,[k]:v}))

  async function enviar(e) {
    e.preventDefault()
    setErro('')
    if (!form.nome || !form.cpf_cnpj || !form.assunto) { setErro('Nome, CPF/CNPJ e assunto são obrigatórios'); return }
    setLoad(true)
    try {
      const r = await api.post('/protocolo-publico/abrir', {
        prefeitura_slug: SLUG,
        prefeitura_slug: SLUG,
        req_nome: form.nome,
        req_cpf_cnpj: form.cpf_cnpj.replace(/\D/g,''),
        req_email: form.email,
        req_telefone: form.telefone,
        assunto: form.assunto
      })
      const proc = r.data
      // Upload de documento se tiver
      if (arquivo) {
        const fd = new FormData(); fd.append('arquivo', arquivo)
        await api.post(`/protocolo-publico/upload/${proc.id}`, fd, { headers:{'Content-Type':'multipart/form-data'} }).catch(()=>{})
      }
      setProtocolo(proc)
    } catch(e) { setErro(e.response?.data?.erro || 'Erro ao abrir protocolo') }
    finally { setLoad(false) }
  }

  const inpStyle = { width:'100%', padding:'11px 14px', border:'1px solid #d1d5db', borderRadius:10, fontSize:15, boxSizing:'border-box' }

  if (protocolo) return (
    <div style={{ minHeight:'100vh', background:'#f0f4f8', fontFamily:'system-ui,sans-serif', display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
      <div style={{ maxWidth:480, width:'100%' }}>
        <div style={{ background:'white', borderRadius:16, border:'1px solid #e5e7eb', overflow:'hidden' }}>
          <div style={{ background:'#EAF3DE', padding:'32px 28px', textAlign:'center' }}>
            <div style={{ fontSize:48, marginBottom:12 }}>✅</div>
            <div style={{ fontSize:18, fontWeight:600, color:'#3B6D11', marginBottom:8 }}>Protocolo aberto!</div>
            <div style={{ fontFamily:'monospace', fontSize:26, fontWeight:700, color:'#185FA5' }}>{protocolo.numero}</div>
          </div>
          <div style={{ padding:28 }}>
            <div style={{ fontSize:14, color:'#374151', lineHeight:1.7, marginBottom:20 }}>
              Sua solicitação foi registrada com sucesso. Guarde o número do protocolo para acompanhar o andamento.
            </div>
            <div style={{ background:'#f9fafb', borderRadius:10, padding:16, marginBottom:20 }}>
              {[['Solicitante', protocolo.req_nome], ['Assunto', protocolo.assunto], ['Aberto em', new Date(protocolo.aberto_em).toLocaleString('pt-BR')]].map(([l,v])=>(
                <div key={l} style={{ marginBottom:10 }}>
                  <div style={{ fontSize:11, color:'#9ca3af' }}>{l}</div>
                  <div style={{ fontSize:13, fontWeight:500 }}>{v}</div>
                </div>
              ))}
            </div>
            <a href={`/consulta`} style={{ display:'block', textAlign:'center', padding:'12px', background:'#185FA5', color:'white', borderRadius:10, fontSize:14, textDecoration:'none', fontWeight:500, marginBottom:10 }}>
              Acompanhar pelo número
            </a>
            <button onClick={()=>{setProtocolo(null);setForm({nome:'',cpf_cnpj:'',email:'',telefone:'',assunto:'',tipoPessoa:'PF'});setArquivo(null)}}
              style={{ width:'100%', padding:'12px', border:'1px solid #d1d5db', borderRadius:10, fontSize:14, cursor:'pointer', background:'white' }}>
              Abrir novo protocolo
            </button>
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <div style={{ minHeight:'100vh', background:'#f0f4f8', fontFamily:'system-ui,sans-serif', padding:'24px 16px' }}>
      <div style={{ maxWidth:520, margin:'0 auto' }}>
        {/* Cabeçalho */}
        <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:'16px 20px', marginBottom:16, display:'flex', alignItems:'center', gap:12 }}>
          {orgao?.logo_url && <img src={orgao.logo_url} alt="Logo" style={{ height:40, objectFit:'contain' }} onError={e=>e.target.style.display='none'} />}
          <div>
            <div style={{ fontSize:14, fontWeight:600 }}>{orgao?.nome || 'Prefeitura Municipal'}</div>
            <div style={{ fontSize:12, color:'#9ca3af' }}>Protocolo Geral</div>
          </div>
        </div>

        <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:24 }}>
          <div style={{ fontSize:16, fontWeight:600, marginBottom:4 }}>📋 Abrir protocolo</div>
          <div style={{ fontSize:13, color:'#9ca3af', marginBottom:24 }}>Preencha o formulário para registrar sua solicitação. Você receberá um número de protocolo para acompanhamento.</div>

          <form onSubmit={enviar}>
            {/* Tipo pessoa */}
            <div style={{ display:'flex', gap:8, marginBottom:16 }}>
              {[['PF','👤 Pessoa Física'],['PJ','🏢 Empresa']].map(([k,l])=>(
                <button key={k} type="button" onClick={()=>set('tipoPessoa',k)}
                  style={{ flex:1, padding:'10px', border:`2px solid ${form.tipoPessoa===k?'#185FA5':'#e5e7eb'}`, borderRadius:8, fontSize:13, cursor:'pointer', background:form.tipoPessoa===k?'#E6F1FB':'white', color:form.tipoPessoa===k?'#185FA5':'#374151', fontWeight:form.tipoPessoa===k?500:400 }}>
                  {l}
                </button>
              ))}
            </div>

            {/* Dados */}
            <div style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Nome completo *</label>
              <input value={form.nome} onChange={e=>set('nome',e.target.value)} required placeholder="Seu nome completo" style={inpStyle} />
            </div>
            <div style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>{form.tipoPessoa==='PF'?'CPF *':'CNPJ *'}</label>
              <input value={form.cpf_cnpj} onChange={e=>set('cpf_cnpj', form.tipoPessoa==='PF'?formatarCPF(e.target.value):formatarCNPJ(e.target.value))} required
                placeholder={form.tipoPessoa==='PF'?'000.000.000-00':'00.000.000/0000-00'} style={inpStyle} />
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:14 }}>
              <div>
                <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>E-mail</label>
                <input type="email" value={form.email} onChange={e=>set('email',e.target.value)} placeholder="seu@email.com" style={inpStyle} />
              </div>
              <div>
                <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Telefone</label>
                <input value={form.telefone} onChange={e=>set('telefone',e.target.value)} placeholder="(00) 00000-0000" style={inpStyle} />
              </div>
            </div>
            <div style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Assunto / Descrição *</label>
              <textarea value={form.assunto} onChange={e=>set('assunto',e.target.value)} required
                placeholder="Descreva sua solicitação com o máximo de detalhes..."
                style={{ ...inpStyle, minHeight:100, resize:'vertical' }} />
            </div>

            {/* Documento opcional */}
            <div style={{ marginBottom:20 }}>
              <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Documento (opcional)</label>
              {arquivo ? (
                <div style={{ display:'flex', alignItems:'center', gap:8, background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, padding:'10px 14px' }}>
                  <span style={{ flex:1, fontSize:13, color:'#15803d' }}>📎 {arquivo.name}</span>
                  <button type="button" onClick={()=>setArquivo(null)} style={{ background:'none', border:'none', color:'#dc2626', cursor:'pointer', fontSize:16 }}>✕</button>
                </div>
              ) : (
                <button type="button" onClick={()=>{const i=document.createElement('input');i.type='file';i.accept='.pdf,.jpg,.jpeg,.png,.doc,.docx';i.onchange=e=>{if(e.target.files[0])setArquivo(e.target.files[0])};i.click()}}
                  style={{ width:'100%', padding:'12px', border:'1.5px dashed #d1d5db', borderRadius:10, fontSize:13, cursor:'pointer', background:'#fafafa', color:'#6b7280' }}>
                  📎 Clique para anexar um documento
                </button>
              )}
            </div>

            {erro && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:12, fontSize:13, color:'#dc2626', marginBottom:14 }}>{erro}</div>}

            <button type="submit" disabled={load}
              style={{ width:'100%', padding:14, background:'#185FA5', color:'white', border:'none', borderRadius:10, fontSize:16, cursor:'pointer', fontWeight:500 }}>
              {load ? '⏳ Enviando...' : 'Abrir protocolo'}
            </button>
          </form>
        </div>

        <div style={{ display:'flex', justifyContent:'center', gap:20, marginTop:16 }}>
          <a href="/consulta" style={{ fontSize:13, color:'#6b7280', textDecoration:'none' }}>Consultar protocolo →</a>
          <a href="/portal" style={{ fontSize:13, color:'#6b7280', textDecoration:'none' }}>Área do cidadão →</a>
        </div>
      </div>
    </div>
  )
}
